import React from "react"
import WinnersStyledBackgroundSection from "../components/winners-background-image"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Img from "gatsby-image"
import Link from "gatsby-link"
import WinnerCard from "../components/WinnerCard";
import { graphql, useStaticQuery } from "gatsby";
import winnersData from "../data/winners.json";

const Awards = () => {
  const data = useStaticQuery(graphql`
  query {
    allImageSharp {
      nodes {
        fluid {
          ...GatsbyImageSharpFluid
          originalName
        }
      }
    }
  }
`);

  // Create a mapping of image original names to fluid data
  const imageMap = data.allImageSharp.nodes.reduce((acc, node) => {
    acc[node.fluid.originalName] = node.fluid;
    return acc;
  }, {});

  return (
    <Layout>
      <Seo title="Winners" />
      <WinnersStyledBackgroundSection />
      {winnersData.map((winner) => (
        <WinnerCard
          key={winner.name}
          imageData={imageMap[winner.imagePath.split('/').pop()]}
          imageAlt={winner.imageAlt}
          name={winner.name}
          awardTitle={winner.awardTitle}
          description={winner.description}
        />
      ))}
      
      <div className="previous-winners-section" style={{ backgroundColor: '#ffffff', padding: '60px 0', position: 'relative', zIndex: 112 }}>
        <div className="container">
          <div className="row">
            <div className="col-sm-12" style={{ maxWidth: '880px', marginLeft: 'auto', marginRight: 'auto' }}>
              <h2 className="h3 mb-5 serif">Previous Winners</h2>
              
              <div className="mb-5">
                <h3 className="h4 mb-3 semibold">2025</h3>
                <p className="copy mb-2">
                  <strong>Professional winners:</strong> Nick Gerda, LAist, and Amelia Ferrell Knisely, West Virginia Watch
                </p>
                <p className="copy">
                  <strong>Student media winners:</strong> Garrett Shanley, Independent Florida Alligator, and Sam Ellefson, Aspen Ford, Reagan Priest, Christopher Lomahquahu, Chad Bradley, Madison Perales, Eshaan Sarup, Mia Berry, Arizona State University Cronkite News
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3 semibold">2024</h3>
                <p className="copy mb-2">
                  <strong>Professional winners:</strong> Michael Riley, David Kocieniewski, Monte Reel, Jessica Brice, Eric Fan, Michael Smith, Natalie Obiko Pearson, Chris Cannon and Henry Baker, <a href="https://www.bloomberg.com/graphics/2023-us-made-gun-exports-shootings-violence-sig-sauer/?embedded-checkout=true" target="_blank" rel="noopener noreferrer">Bloomberg News</a>
                </p>
                <p className="copy">
                  <strong>Student media winners:</strong> Theo Baker, Stanford University, <a href="https://stanforddaily.com/2023/07/19/stanford-president-resigns-over-manipulated-research-will-retract-at-least-3-papers/" target="_blank" rel="noopener noreferrer">Stanford Daily</a>; Nicole Markus, Alyce Brown, Cole Reynolds and Divya Bhardwaj, Northwestern University, <a href="https://dailynorthwestern.com/2023/07/08/top-stories/former-nu-football-player-details-hazing-allegations-after-coach-suspension/" target="_blank" rel="noopener noreferrer">Daily Northwestern</a>; University of North Carolina, <a href="https://www.dailytarheel.com/article/2023/08/breaking-news-armed-individual-on-campus-08282023" target="_blank" rel="noopener noreferrer">Daily Tar Heel</a> staff
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3 semibold">2023</h3>
                <p className="copy mb-2">
                  <strong>Professional winners:</strong> Brian van der Brug and Paige St. John, <a href="https://www.latimes.com/california/story/2022-09-08/a-series-on-the-fallout-of-legal-weed-in-california" target="_blank" rel="noopener noreferrer">Los Angeles Times</a>, and Ian Urbina, <a href="https://www.theoutlawocean.com/the-outlaw-ocean-podcast/" target="_blank" rel="noopener noreferrer">"The Outlaw Ocean Project"</a>
                </p>
                <p className="copy">
                  <strong>Student media winner:</strong> Evan Gerike, Indiana University, <a href="https://specials.idsnews.com/indiana-volleyball-steve-aird-culture-fear/index.html#:~:text=The%20players%20said%20they%20were,abused%20his%20position%20of%20power." target="_blank" rel="noopener noreferrer">Indiana Daily Student</a>
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3 semibold">2022</h3>
                <p className="copy mb-2">
                  <strong>Professional winner:</strong> Richard Webster, <a href="https://www.propublica.org/series/unwatched" target="_blank" rel="noopener noreferrer">"Unwatched"</a>
                </p>
                <p className="copy">
                  <strong>Student media winner:</strong> Zachary Huber, University of Florida, <a href="https://www.alligator.org/article/2021/09/former-florida-womens-basketball-players-detail-abuse-under-coach-newbauer" target="_blank" rel="noopener noreferrer">Independent Florida Alligator</a>
                </p>
              </div>

              <div className="mb-5">
                <h3 className="h4 mb-3 semibold">2021</h3>
                <p className="copy mb-2">
                  <strong>Professional winner:</strong> Tony Plohetski, <a href="https://www.statesman.com/story/news/investigations/2020/06/08/texas-police-chase-ends-death-i-cant-breathe-man-cries/3137476001/" target="_blank" rel="noopener noreferrer">Austin American-Statesman and KVUE</a>
                </p>
                <p className="copy">
                  <strong>Student media winner:</strong> Madeleine Davison, Syracuse University, <a href="https://dailyorange.com/2020/03/nursing-center-violations-increase-profit-company-ownership/" target="_blank" rel="noopener noreferrer">Daily Orange</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Layout>
  )
}

export default Awards
